import { gql } from '@apollo/client';

const GET_COUNTRY_ENUM_VALUES_QUERY = gql`
  query getCountryEnumValues {
    countryEnums: __type(name: "ECountry") {
      enumValues {
        key: name
        value: description
      }
    }
  }
`;

export { GET_COUNTRY_ENUM_VALUES_QUERY };
